// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"279ef5a7","667":"e232e5d7","737":"38dcc4cb","977":"6cab2041"}[chunkId] + ".chunk.js";
};